import { Scene, Choice, Dialog } from "../models";
import { scenes } from "../scenes";

export class OfficeInterior extends Scene {
  title = "Shibari International Office";
  image = require("@/images/Shibari_Office_Corridor.png");
  get options(): any[] {
    return [
      new Choice("Enter Human Resources Manager’s Office", async () => {
        await this.navigate(scenes.HumanResources());
      }),
      new Choice(
        "Speak to Essential Employees",
        async () => await this.navigate(scenes.EssentialEmployees())
      ),
      new Choice(
        "Use Elevator",
        async () => await this.navigate(scenes.Elevator())
      ),
    ];
  }
}

export default new OfficeInterior();
